<template>
  <div id="pagination-app">
    <div v-if="providerResultsShowing < providers.length">
      <p class="p-large">
        Showing <strong>{{ providerResultsShowing }}</strong> out of
        <strong>{{ providers.length }}</strong> therapists
      </p>
    </div>
    <div v-else>
      <p class="p-large">
        Showing <strong>{{ providers.length }}</strong> out of
        <strong>{{ providers.length }}</strong> therapists
      </p>
    </div>
    <div v-for="(provider, index) in providerLoaded" :key="index">
      <ResultCard
        :isTab2="false"
        :culturalExperience="provider.CulturalExpertise"
        :firstName="provider.FirstName"
        :gender="provider.Gender"
        :languages="provider.Languages"
        :regions="provider.Regions"
        :surname="provider.LastName"
        :therapistExperience="provider.TherapistExpertise"
      ></ResultCard>
    </div>
    <div v-if="providerResultsShowing < providers.length">
      <p class="p-large">
        Showing <strong>{{ providerResultsShowing }}</strong> out of
        <strong>{{ providers.length }}</strong> therapists
      </p>
    </div>
    <div v-else>
      <p class="p-large">
        Showing <strong>{{ providers.length }}</strong> out of
        <strong>{{ providers.length }}</strong> therapists
      </p>
    </div>
    <div
      class="button__wrapper-center"
      v-if="
        providerResultsShowing < providers.length ||
          providers.length > providerResultsShowing
      "
    >
      <button
        aria-label="Load more results"
        class="button button-tertiary"
        @click="providerResultsShowing += 20"
      >
        See more
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ResultCard from "./components/ResultCard.vue";

export default Vue.component("PaginationApp", {
  data() {
    return {
      providerResultsShowing: 20,
    };
  },
  props: {
    isTab2: Boolean,
    providers: Array,
  },
  methods: {
    loadMore() {
      if (this.providerResultsShowing > this.providers.providerResultsShowing)
        return;
      this.providerResultsShowing = this.providerResultsShowing + 3;
    },
  },
  computed: {
    providerLoaded() {
      return this.providers.slice(0, this.providerResultsShowing);
    },
  },
  components: {
    ResultCard,
  },
});
</script>
